module.exports = __webpack_public_path__ + "public/images/about-15.5445313a8539b1a49dea66538f914b3f.jpg";